import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import legalNatureReadAction from './legalNatureRead.action.json' with { type: 'json' }

const legalNatureReadDefinition = defineReadAutoAction(legalNatureReadAction, 'legalNature')

export default legalNatureReadDefinition
